import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import SubscriptionOffcanvas from './SubscriptionOffcanvas';
import subscriptionPlans from './subscriptionPlans';
import 'swiper/css';
import 'swiper/css/pagination';
import './Subscription.css';
import { useTranslation } from 'react-i18next';

const Subscription = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedPlan = location.state?.selectedPlan || 'plus';
  const [currentPlan, setCurrentPlan] = useState(selectedPlan);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const { t } = useTranslation();

  const formatPrice = (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  const getLowestPrice = (plan) => {
    return Math.min(...plan.prices.map(price => parseInt(price.price)));
  };

  useEffect(() => {
    if (swiperInstance) {
      const planIndex = Object.keys(subscriptionPlans).indexOf(selectedPlan);
      if (planIndex !== -1) {
        swiperInstance.slideTo(planIndex, 0);
      }
    }
  }, [swiperInstance, selectedPlan]);

  const handleSlideChange = (swiper) => {
    const plans = Object.keys(subscriptionPlans);
    setCurrentPlan(plans[swiper.activeIndex]);
  };

  const handleShowOffcanvas = () => setShowOffcanvas(true);
  const handleCloseOffcanvas = () => setShowOffcanvas(false);

  return (
    <div className="content-body page-wrapper  subscription">
      <header className="header header-fixed bg-white">
        <div className="container">
          <div className="header-content">
            <div className="left-content me-3">
              <button onClick={() => navigate(-1)} className="back-btn">
                <i className="icon feather icon-chevron-left"></i>
              </button>
              <h6 className="title">My Subscription</h6>
            </div>
          </div>
        </div>
      </header>

      <div className="page-content">
        <div className="container">
          <div className="dz-subscribe-area">
            <div className="subscribe-area-top">
              <Swiper
                onSwiper={setSwiperInstance}
                initialSlide={Object.keys(subscriptionPlans).indexOf(selectedPlan)}
                modules={[Pagination]}
                pagination={{
                  el: '.swiper-pagination',
                  clickable: true,
                  type: 'bullets',
                }}
                onSlideChange={handleSlideChange}
                className="subscription-swiper2"
              >
                {Object.entries(subscriptionPlans).map(([key, plan]) => (
                  <SwiperSlide key={key} data-card={key}>
                    <div className={`subscribe-box ${key}`}>
                      <div className="logo-img">
                        <img src={require('../../assets/images/fulllogo_transparent_nobuffer.png')} alt="Trakna" />
                        <span className="badge">{t(plan.name)}</span>
                      </div>
                    </div>
                    <div className="plan-description">
                      <p>{t(plan.description)}</p>
                    </div>
                  </SwiperSlide>
                ))}
                <div className="swiper-btn">
                  <div className="swiper-pagination style-1 flex-1"></div>
                </div>
              </Swiper>
            </div>

            {Object.entries(subscriptionPlans).map(([key, plan]) => (
              <div 
                key={key} 
                className={`subscribe-content ${key} ${currentPlan === key ? '' : 'd-none'}`} 
                id={key}
              >
                <ul className="pricing-data">
                  {plan.features.map((feature, index) => (
                    <li key={index} className={feature.included ? 'list-true' : 'list-false'}>
                      <i className={`icon feather icon-${feature.included ? 'check' : 'lock'}`}></i>
                      <span>{t(feature.key)}</span>
                    </li>
                  ))}
                </ul>
                <div className="bottom-btn bg-white text-center">
                  <button 
                    className="btn btn-gradient dz-flex-box btn-shadow rounded-xl"
                    onClick={handleShowOffcanvas}
                  >
                    <div className="price-info">
                      <div className="price">À partir de {formatPrice(getLowestPrice(subscriptionPlans[currentPlan]))} FCFA</div>
                    </div>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <SubscriptionOffcanvas
        show={showOffcanvas}
        onClose={handleCloseOffcanvas}
        planType={currentPlan}
      />
    </div>
  );
};

export default Subscription;
